import { render, staticRenderFns } from "./ProjectDetail.vue?vue&type=template&id=2a467f76&scoped=true&"
import script from "./ProjectDetail.vue?vue&type=script&lang=ts&"
export * from "./ProjectDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectDetail.vue?vue&type=style&index=0&id=2a467f76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a467f76",
  null
  
)

export default component.exports